// Plain types and constants shared by the server and web app. Kept free of
// zod so importing it doesn't pull the validator into the web bundle; the
// request schema lives in src/invitation-routes.ts.

export const invitationStatuses = ["pending", "accepted", "expired", "revoked"] as const;
export type InvitationStatus = (typeof invitationStatuses)[number];

export const invitationExpiryOptions = [
  { hours: 24, label: "1 day" },
  { hours: 72, label: "3 days" },
  { hours: 168, label: "7 days" },
  { hours: 336, label: "14 days" },
  { hours: 720, label: "30 days" }
] as const;

/** The console lists at most this many of the newest invitations. */
export const invitationListLimit = 200;

export type Invitation = {
  id: string;
  email: string;
  status: InvitationStatus;
  invitedBy: string | null;
  createdAt: string;
  expiresAt: string;
  acceptedAt: string | null;
  revokedAt: string | null;
};

export type CreatedInvitation = {
  id: string;
  email: string;
  expiresAt: string;
  /** One-time sign-up link; only shown right after sending. */
  actionUrl: string;
  /** Older pending invitations for the same address that this one replaced. */
  superseded: string[];
};
